import { sortCaret } from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./personnel-report-table/column-formatters";

export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "10", page: 10 },
  { text: "25", page: 25 },
  { text: "50", page: 50 },
  { text: "100", page: 100 }
];
export const initialFilter = {
  filter: {},
  sortOrder: "asc", // asc||desc
  sortField: "personnelType",
  pageNumber: 1,
  pageSize: 10
};
// Initial table columns
export const initialColumns = [
  {
    dataField: "photoStr",
    text: "Fotoğraf",
    formatter: columnFormatters.PhotoColumnFormatter,
    style: {
      minWidth: "100px"
    }
  },
  {
    dataField: "personnelType",
    text: "Personel Türü",
    sort: true,
    width: 25,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "tcKimlikNo",
    text: "TC Kimlik No",
    sort: true,
    width: 25,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "name",
    text: "Adı",
    sort: true,
    width: 25,
    sortCaret: sortCaret,
    style: {
      minWidth: "135px"
    }
  },    
  {
    dataField: "surname",
    text: "Soyadı",
    sort: true,
    width: 25,
    sortCaret: sortCaret,
    style: {
      minWidth: "135px"
    }
  },  
  {
    dataField: "sexName",
    text: "Cinsiyeti",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "120px"
    }
  },
  {
    dataField: "birthDate",
    text: "Doğum Tarihi",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "birthPlace",
    text: "Doğum Yeri",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "130px"
    }
  },
  {
    dataField: "maritalStatusName",
    text: "Medeni Hali",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "130px"
    }
  },
  {
    dataField: "mobilePhone",
    text: "Cep Telefonu",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "140px"
    }
  },
  {
    dataField: "homePhone",
    text: "Ev Telefonu",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "130px"
    }
  },
  {
    dataField: "email",
    text: "Email",
    sort: true,
    width: 35,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "130px"
    }
  },
  {
    dataField: "address",
    text: "Adres",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "250px"
    }
  },
  {
    dataField: "graduationTypeName",
    text: "Eğitim Durumu",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "graduateUniversity",
    text: "Lisans Üniversitesi",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "200px"
    }
  },
  {
    dataField: "graduateDepartment",
    text: "Lisans Bölümü",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "200px"
    }
  },
  {
    dataField: "graduateGraduationYear",
    text: "Lisans Mezuniyet Yılı",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "200px"
    }
  },
  {
    dataField: "postGraduateUniversity",
    text: "Yüksek Lisans Üniversitesi",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "240px"
    }
  },
  {
    dataField: "postGraduateDepartment",
    text: "Yüksek Lisans Bölümü",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "225px"
    }
  },
  {
    dataField: "postGraduateGraduationYear",
    text: "Yüksek Lisans Mezuniyet Yılı",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "260px"
    }
  },
  {
    dataField: "doctorateUniversity",
    text: "Doktora Üniversitesi",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "225px"
    }
  },
  {
    dataField: "doctorateDepartment",
    text: "Doktora Bölümü",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "200px"
    }
  },
  {
    dataField: "doctorateGraduationYear",
    text: "Doktora Mezuniyet Yılı",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "225px"
    }
  },
  {
    dataField: "serviceYear",
    text: "Hizmet Yılı",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "130px"
    }
  },
  {
    dataField: "workingYearInTheSchool",
    text: "Okulda Çalışma Yılı",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "200px"
    }
  },
  {
    dataField: "yearOfSeniority",
    text: "Kıdem Yılı",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "130px"
    }
  },
  {
    dataField: "formalContractStartDate",
    text: "Resmi Sözleşme Başlangıç Tarihi",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "300px"
    }
  },
  {
    dataField: "formalContractEndDate",
    text: "Resmi Sözleşme Bitiş Tarihi",
    sort: true,
    width: 35,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "250px"
    }
  },
  {
    dataField: "contractStartDate",
    text: "Sözleşme Başlangıç Tarihi",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "250px"
    }
  },
  {
    dataField: "contractEndDate",
    text: "Sözleşme Bitiş Tarihi",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "225px"
    }
  },
  {
    dataField: "insuranceName",
    text: "Sigorta Türü",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "insuranceStartDate",
    text: "Sigorta Başlangıç Tarihi",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "240px"
    }
  },
  {
    dataField: "insuranceEndDate",
    text: "Sigorta Bitiş Tarihi",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "200px"
    }
  },
  {
    dataField: "formalSalary",
    text: "Resmi Maaşı",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "salary",
    text: "Maaşı",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "120px"
    }
  },
  {
    dataField: "bank",
    text: "Banka",
    sort: true,
    width: 25,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "accountNo",
    text: "Hesap No",
    sort: true,
    width: 25,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "iban",
    text: "Iban",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "250px"
    }
  }
];